import * as api from '../../services/global'
//侧边栏折叠和展开
export const SIDER_COLLAPSED_EXPAND = 'SIDER_COLLAPSED_EXPAND';
//最近的一次加载页面信息
export const SET_LAST_LOCATION = 'LAST_LOCATION';
export const SAVED_REQUEST = 'SAVED_REQUEST';
//微信登陆成功的信息
export const LOGINBYOAUTH = 'LOGINBYOAUTH';


export const siderCollapsedExpand = (collapsed) => ({type: SIDER_COLLAPSED_EXPAND, collapsed});
export const setLastLocation = (location, tableScrollTop) => ({type: SET_LAST_LOCATION, location, tableScrollTop});
export const savedRequest = (pathname) => ({type: SAVED_REQUEST, pathname});
export const fetchLoginByOAuth = (data) => ({
    type: LOGINBYOAUTH,
    payload: {
        promise: api.loginByOAuth(data)
    }
});



// WEBPACK FOOTER //
// ./src/redux/actions/global.js